import { Component, Input, OnChanges } from "@angular/core";
import { AccountService } from "../../models/account.service";
import { StatsNormalizerService } from "../../stats-normalizer/stats-normalizer.service";
import { TimeDurAgoService } from "../../time-dur-ago/time-dur-ago.service";
import { sum } from "../../utils/sum";

@Component({
  selector: "ab-route-cards",
  templateUrl: "./route-cards.component.html",
})
export class RouteCardsComponent implements OnChanges {
  @Input() public routesStats: any;
  @Input() public statusCode: any;
  @Input() public loading: boolean;
  @Input() public project: any;
  @Input() public dur: string;
  @Input() public lastN: number;
  @Input() public errorRateList: number[];
  @Input() public showPerformanceBreakdown: boolean;

  public requestCount: number;
  public requestMean: number;
  public successCount: number;
  public redirectionCount: number;
  public clientErrorCount: number;
  public serverErrorCount: number;
  public errorRate: number;
  public requestCountPerMin: number;
  public requestCountList: number[];
  public requestMeanList: number[];
  public codesBar: {
    success: number;
    redirection: number;
    clientError: number;
    serverError: number;
  };
  public accountApmCapReached: boolean;

  constructor(
    private accountService: AccountService,
    private timeDurAgoService: TimeDurAgoService,
    private statsNormalizerService: StatsNormalizerService,
  ) {}

  public ngOnChanges() {
    this.requestCount = 0;
    this.requestMean = 0;
    this.successCount = 0;
    this.redirectionCount = 0;
    this.clientErrorCount = 0;
    this.serverErrorCount = 0;
    this.errorRate = 0;

    this.requestCountPerMin = 0;

    this.codesBar = {
      success: 0,
      redirection: 0,
      clientError: 0,
      serverError: 0,
    };

    this.accountService.properties().subscribe((props: any) => {
      this.accountApmCapReached = props.alerts.apm_cap_alert === true;
    });

    if (
      !this.routesStats ||
      !this.statusCode ||
      this.statusCode.count.length === 0
    ) {
      return;
    }

    this.calcRoutesStats();
  }

  private calcRoutesStats() {
    const count = sum(this.statusCode.count);
    const mean = sum(this.statusCode.mean);

    this.requestCount = count;
    this.requestMean = mean / this.statusCode.mean.length;

    this.requestCountList = this.populateEmptyDaysWithZeros(
      this.statusCode.count,
      this.routesStats.time,
    );
    this.requestMeanList = this.populateEmptyDaysWithZeros(
      this.statusCode.mean,
      this.routesStats.time,
    );

    if (this.statusCode.name === "total") {
      this.successCount = sum(this.routesStats.success.count);
      this.redirectionCount = sum(this.routesStats.redirection.count);
      this.clientErrorCount = sum(this.routesStats.clientError.count);
      this.serverErrorCount = sum(this.routesStats.serverError.count);

      const noticeCount = sum(this.routesStats.noticeCount);
      this.errorRate = 100 * (noticeCount / this.requestCount);
    } else {
      const statusCount = sum(this.statusCode.count);
      switch (this.statusCode.name[0]) {
        case "2":
          this.successCount = statusCount;
          break;
        case "3":
          this.redirectionCount = statusCount;
          break;
        case "4":
          this.clientErrorCount = statusCount;
          break;
        case "5":
          this.serverErrorCount = statusCount;
          break;
        default:
          (this as any)[`${this.statusCode.name}Count`] = statusCount;
      }
    }

    this.codesBar = {
      success: this.successCount,
      redirection: this.redirectionCount,
      clientError: this.clientErrorCount,
      serverError: this.serverErrorCount,
    };

    this.calculateRequestsPerMin();
  }

  private calculateRequestsPerMin() {
    const time = this.timeDurAgoService.inMinutes(this.dur, this.lastN);
    this.requestCountPerMin = this.requestCount / time;
  }

  private populateEmptyDaysWithZeros(stats: number[], time: string[]) {
    return this.statsNormalizerService.populateEmptyDaysWithZeros(
      stats,
      time,
      this.dur,
      this.lastN,
    );
  }
}
